import { AlertType, RepeatAlarm, } from "@reducers/access-points/models/access-point-dto";
const validRepeat = new Set([
    RepeatAlarm.AlarmRepeatUntilResolved,
    RepeatAlarm.AlaramRepeats3Times,
    RepeatAlarm.NoRepeat,
]);
const validAlert = new Set([
    AlertType.EmailAndSMS,
    AlertType.EmailOnly,
    AlertType.SMSOnly,
    AlertType.WhatsAppOnly,
    AlertType.EmailAndWhatsApp,
    AlertType.SmsAndWhatsApp,
    AlertType.EmailSmsAndWhatsApp,
]);
/** Map API / legacy 0 or invalid values to a select field value (never "0"). */
export function repeatAlarmToSelectValue(v) {
    if (v == null || v === 0 || !validRepeat.has(v)) {
        return String(RepeatAlarm.NoRepeat);
    }
    return String(v);
}
/**
 * Select value of the General "Alerting" field: email/SMS only (WhatsApp has its own section). A former combined value
 * keeps its email/SMS part, as the API does: Email & WhatsApp → Email only, SMS & WhatsApp → SMS only, WhatsApp only
 * and all three → Email & SMS.
 */
export function alertTypeToSelectValue(v) {
    if (v == null || v === 0 || !validAlert.has(v)) {
        return String(AlertType.EmailAndSMS);
    }
    if (v === AlertType.EmailAndWhatsApp)
        return String(AlertType.EmailOnly);
    if (v === AlertType.SmsAndWhatsApp)
        return String(AlertType.SMSOnly);
    if (v === AlertType.WhatsAppOnly || v === AlertType.EmailSmsAndWhatsApp)
        return String(AlertType.EmailAndSMS);
    return String(v);
}
export function parseRepeatAlarmOrDefault(raw) {
    const n = raw != null && raw !== "" ? parseInt(raw, 10) : NaN;
    if (!Number.isFinite(n) || n === 0 || !validRepeat.has(n)) {
        return RepeatAlarm.NoRepeat;
    }
    return n;
}
export function parseAlertTypeOrDefault(raw) {
    const n = raw != null && raw !== "" ? parseInt(raw, 10) : NaN;
    if (!Number.isFinite(n) || n === 0 || !validAlert.has(n)) {
        return AlertType.EmailAndSMS;
    }
    return n;
}
